var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Tabs, { TabList, useTab, useTabPanel, } from "@atlaskit/tabs";
import Tooltip from "@atlaskit/tooltip";
import React from "react";
import LoggingPage from "../pages/LoggingPage";
import PollinatorPage from "../pages/PollinatorPage";
var panelStyles = {
    width: "100%",
};
var TabPanel = function (_a) {
    var children = _a.children, testId = _a.testId;
    var tabPanelAttributes = useTabPanel();
    return (React.createElement("div", __assign({ "data-testid": testId }, tabPanelAttributes), children));
};
export var Panel = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { style: panelStyles }, children));
};
var CustomTab = function (_a) {
    var label = _a.label;
    var tabAttributes = useTab();
    // There is a type error but this is just copied from the docs for a custom tab
    // https://atlassian.design/components/tabs/examples#custom-tab
    // @ts-ignore: Incompatible attributes error
    return React.createElement("div", __assign({}, tabAttributes), label);
};
var TooltipTab = function (_a) {
    var label = _a.label, tooltip = _a.tooltip;
    return (React.createElement(Tooltip, { content: tooltip },
        React.createElement(CustomTab, { label: label })));
};
var TabContainer = function (_a) {
    var id = _a.id;
    return (React.createElement("div", { style: { padding: "1rem" } },
        React.createElement(Tabs, { id: "tooltip-tabs" },
            React.createElement(TabList, null,
                React.createElement(TooltipTab, { label: "Logging", tooltip: "Service Logging Metadata" }),
                React.createElement(TooltipTab, { label: "Pollinator", tooltip: "Pollinator Checks" })),
            React.createElement(TabPanel, null,
                React.createElement(Panel, null,
                    React.createElement(LoggingPage, { id: id }))),
            React.createElement(TabPanel, null,
                React.createElement(Panel, null,
                    React.createElement(PollinatorPage, null))))));
};
export default TabContainer;
